import axios from 'axios';
import { SubmissionError } from 'redux-form';
import jwtDecode from 'jwt-decode';
import { setPartner, setInitialState, setFlippers } from '../reducer';
import { setToken } from '../../utilities/tokenStorage';
import { getFlippers } from '../sagas';

const handleSubmit = async (values, dispatch) => {
  const url = '/sessions';
  try {
    const response = await axios.post(url, values);
    handleResponse(response, dispatch);
    return response;
  } catch (error) {
    throw new SubmissionError({
      _error:
        ((error.response || {}).data || {}).details ||
        'There was a problem submitting your request'
    });
  }
};

function handleResponse(response, dispatch) {
  try {
    const token = (response.headers || {})['x-token'];
    const partnerDetails = jwtDecode(token);
    setToken(token);
    // getFlippers also needs to be called here to set the flippers on intial user login.
    const flippers = getFlippers();
    flippers.then(res => {
      dispatch(setFlippers(res.data));
    });
    dispatch(setInitialState(response.data.initial_state));
    dispatch(setPartner(partnerDetails));
  } catch (error) {
    console.error(error);
    //
  }
}

export default handleSubmit;
